import action from 'utils/createAction';
import APP from 'types/app';

export default {
  init: (payload) => action(APP.INIT, payload),
  setId: (id) => action(APP.SET_ID, id),
  setDataReady: (isReady) => action(APP.SET_DATA_READY, isReady),
  setPathname: (data) => action(APP.SET_PATHNAME, data),
  resetSubscriptionVideoCollections: () => action(APP.RESET_SUBSCRIPTIONS_VIDEO_COLLECTIONS),
  forceDataUpdate: () => action(APP.FORCE_DATA_UPDATE),
  resetServiceApiData: (type) => action(APP.RESET_SERVICE_API_DATA, type),
  removeApiResponseError: (type, field) => action(APP.REMOVE_API_RESPONSE_ERROR, { type, field }),
  forceLogout: () => action(APP.FORCE_LOGOUT),
  getLoginInputValue: (data) => action(APP.LOGIN_INPUT_VALUE, { data }),
  saveMoviePosition: (objectId, movieId, position, percent) =>
    action(APP.SAVE_MOVIE_POSITION, {
      objectId,
      movieId,
      position,
      percent,
    }),
  setStorageAccess: (hasAccess) => ({ type: APP.HAS_STORAGE_ACCESS, hasAccess }),
};
